export const mapLayerTypes = [
  {
    key: 'carto',
    name: 'mapCarto'
  },
  {
    key: 'osm',
    name: 'mapOsm'
  },
  {
    key: 'googleTerrain',
    name: 'mapGoogleTerrain'
  },
  {
    key: 'googleSatellite',
    name: 'mapGoogleSatellite'
  },
  {
    key: 'googleHybrid',
    name: 'mapGoogleHybrid'
  },
  {
    key: 'googleRoad',
    name: 'mapGoogleRoad'
  },
  {
    key: 'yandexMap',
    name: 'mapYandexMap'
  },
  {
    key: 'yandexSat',
    name: 'mapYandexSat'
  },
  {
    key: 'baidu',
    name: 'mapBaidu'
  },
  {
    key: 'gccStreet',
    name: 'mapGccStreet'
  }
]

export const coordinateFormatTypes = [
  {
    key: 'dd',
    name: 'sharedDecimalDegrees'
  },
  {
    key: 'ddm',
    name: 'sharedDegreesDecimalMinutes'
  },
  {
    key: 'dms',
    name: 'sharedDegreesMinutesSeconds'
  }
]

export const ownerUserType = [
  {
    key: 1,
    name: 'user'
  },
  {
    key: 2,
    name: 'userAdmin'
  }
]
export const dealerUserType = [
  {
    key: 1,
    name: 'user'
  },
  {
    key: 2,
    name: 'userAdmin'
  }
]
export const adminAccountUserType = [
  {
    key: 1,
    name: 'user'
  },
  {
    key: 2,
    name: 'userAdmin'
  }
]
export const serviceProviderUserType = [
  {
    key: 1,
    name: 'user'
  },
  {
    key: 2,
    name: 'userAdmin'
  }
]
export const adminUserType = [
  {
    key: 1,
    name: 'user'
  }
]

export const measurementStandard = [
  {
    key: 'metric',
    value: 'Metric'
  },
  {
    key: 'imperial',
    value: 'Imperial'
  },
  {
    key: 'US',
    value: 'US'
  }, {
    key: 'metricWithUSGallons',
    value: 'Metric with US Gallons'
  }
]

export const currencies = [
  {
      "key": "US Dollar",
      "value": "USD"
  },
  {
      "key": "Canadian Dollar",
      "value": "CAD"
  },
  {
      "key": "Euro",
      "value": "EUR"
  },
  {
      "key": "United Arab Emirates Dirham",
      "value": "AED"
  },
  {
      "key": "Afghan Afghani",
      "value": "AFN"
  },
  {
      "key": "Albanian Lek",
      "value": "ALL"
  },
  {
      "key": "Armenian Dram",
      "value": "AMD"
  },
  {
      "key": "Argentine Peso",
      "value": "ARS"
  },
  {
      "key": "Australian Dollar",
      "value": "AUD"
  },
  {
      "key": "Azerbaijani Manat",
      "value": "AZN"
  },
  {
      "key": "Bosnia-Herzegovina Convertible Mark",
      "value": "BAM"
  },
  {
      "key": "Bangladeshi Taka",
      "value": "BDT"
  },
  {
      "key": "Bulgarian Lev",
      "value": "BGN"
  },
  {
      "key": "Bahraini Dinar",
      "value": "BHD"
  },
  {
      "key": "Burundian Franc",
      "value": "BIF"
  },
  {
      "key": "Brunei Dollar",
      "value": "BND"
  },
  {
      "key": "Bolivian Boliviano",
      "value": "BOB"
  },
  {
      "key": "Brazilian Real",
      "value": "BRL"
  },
  {
      "key": "Botswanan Pula",
      "value": "BWP"
  },
  {
      "key": "Belarusian Ruble",
      "value": "BYN"
  },
  {
      "key": "Belize Dollar",
      "value": "BZD"
  },
  {
      "key": "Congolese Franc",
      "value": "CDF"
  },
  {
      "key": "Swiss Franc",
      "value": "CHF"
  },
  {
      "key": "Chilean Peso",
      "value": "CLP"
  },
  {
      "key": "Chinese Yuan",
      "value": "CNY"
  },
  {
      "key": "Colombian Peso",
      "value": "COP"
  },
  {
      "key": "Costa Rican Colón",
      "value": "CRC"
  },
  {
      "key": "Cape Verdean Escudo",
      "value": "CVE"
  },
  {
      "key": "Czech Republic Koruna",
      "value": "CZK"
  },
  {
      "key": "Djiboutian Franc",
      "value": "DJF"
  },
  {
      "key": "Danish Krone",
      "value": "DKK"
  },
  {
      "key": "Dominican Peso",
      "value": "DOP"
  },
  {
      "key": "Algerian Dinar",
      "value": "DZD"
  },
  {
      "key": "Estonian Kroon",
      "value": "EEK"
  },
  {
      "key": "Egyptian Pound",
      "value": "EGP"
  },
  {
      "key": "Eritrean Nakfa",
      "value": "ERN"
  },
  {
      "key": "Ethiopian Birr",
      "value": "ETB"
  },
  {
      "key": "British Pound Sterling",
      "value": "GBP"
  },
  {
      "key": "Georgian Lari",
      "value": "GEL"
  },
  {
      "key": "Ghanaian Cedi",
      "value": "GHS"
  },
  {
      "key": "Guinean Franc",
      "value": "GNF"
  },
  {
      "key": "Guatemalan Quetzal",
      "value": "GTQ"
  },
  {
      "key": "Hong Kong Dollar",
      "value": "HKD"
  },
  {
      "key": "Honduran Lempira",
      "value": "HNL"
  },
  {
      "key": "Croatian Kuna",
      "value": "HRK"
  },
  {
      "key": "Hungarian Forint",
      "value": "HUF"
  },
  {
      "key": "Indonesian Rupiah",
      "value": "IDR"
  },
  {
      "key": "Israeli New Sheqel",
      "value": "ILS"
  },
  {
      "key": "Indian Rupee",
      "value": "INR"
  },
  {
      "key": "Iraqi Dinar",
      "value": "IQD"
  },
  {
      "key": "Iranian Rial",
      "value": "IRR"
  },
  {
      "key": "Icelandic Króna",
      "value": "ISK"
  },
  {
      "key": "Jamaican Dollar",
      "value": "JMD"
  },
  {
      "key": "Jordanian Dinar",
      "value": "JOD"
  },
  {
      "key": "Japanese Yen",
      "value": "JPY"
  },
  {
      "key": "Kenyan Shilling",
      "value": "KES"
  },
  {
      "key": "Cambodian Riel",
      "value": "KHR"
  },
  {
      "key": "Comorian Franc",
      "value": "KMF"
  },
  {
      "key": "South Korean Won",
      "value": "KRW"
  },
  {
      "key": "Kuwaiti Dinar",
      "value": "KWD"
  },
  {
      "key": "Kazakhstani Tenge",
      "value": "KZT"
  },
  {
      "key": "Lebanese Pound",
      "value": "LBP"
  },
  {
      "key": "Sri Lankan Rupee",
      "value": "LKR"
  },
  {
      "key": "Lithuanian Litas",
      "value": "LTL"
  },
  {
      "key": "Latvian Lats",
      "value": "LVL"
  },
  {
      "key": "Libyan Dinar",
      "value": "LYD"
  },
  {
      "key": "Moroccan Dirham",
      "value": "MAD"
  },
  {
      "key": "Moldovan Leu",
      "value": "MDL"
  },
  {
      "key": "Malagasy Ariary",
      "value": "MGA"
  },
  {
      "key": "Macedonian Denar",
      "value": "MKD"
  },
  {
      "key": "Myanma Kyat",
      "value": "MMK"
  },
  {
      "key": "Macanese Pataca",
      "value": "MOP"
  },
  {
      "key": "Mauritian Rupee",
      "value": "MUR"
  },
  {
      "key": "Mexican Peso",
      "value": "MXN"
  },
  {
      "key": "Malaysian Ringgit",
      "value": "MYR"
  },
  {
      "key": "Mozambican Metical",
      "value": "MZN"
  },
  {
      "key": "Namibian Dollar",
      "value": "NAD"
  },
  {
      "key": "Nigerian Naira",
      "value": "NGN"
  },
  {
      "key": "Nicaraguan Córdoba",
      "value": "NIO"
  },
  {
      "key": "Norwegian Krone",
      "value": "NOK"
  },
  {
      "key": "Nepalese Rupee",
      "value": "NPR"
  },
  {
      "key": "New Zealand Dollar",
      "value": "NZD"
  },
  {
      "key": "Omani Rial",
      "value": "OMR"
  },
  {
      "key": "Panamanian Balboa",
      "value": "PAB"
  },
  {
      "key": "Peruvian Nuevo Sol",
      "value": "PEN"
  },
  {
      "key": "Philippine Peso",
      "value": "PHP"
  },
  {
      "key": "Pakistani Rupee",
      "value": "PKR"
  },
  {
      "key": "Polish Zloty",
      "value": "PLN"
  },
  {
      "key": "Paraguayan Guarani",
      "value": "PYG"
  },
  {
      "key": "Qatari Rial",
      "value": "QAR"
  },
  {
      "key": "Romanian Leu",
      "value": "RON"
  },
  {
      "key": "Serbian Dinar",
      "value": "RSD"
  },
  {
      "key": "Russian Ruble",
      "value": "RUB"
  },
  {
      "key": "Rwandan Franc",
      "value": "RWF"
  },
  {
      "key": "Saudi Riyal",
      "value": "SAR"
  },
  {
      "key": "Sudanese Pound",
      "value": "SDG"
  },
  {
      "key": "Swedish Krona",
      "value": "SEK"
  },
  {
      "key": "Singapore Dollar",
      "value": "SGD"
  },
  {
      "key": "Somali Shilling",
      "value": "SOS"
  },
  {
      "key": "Syrian Pound",
      "value": "SYP"
  },
  {
      "key": "Thai Baht",
      "value": "THB"
  },
  {
      "key": "Tunisian Dinar",
      "value": "TND"
  },
  {
      "key": "Tongan Paʻanga",
      "value": "TOP"
  },
  {
      "key": "Turkish Lira",
      "value": "TRY"
  },
  {
      "key": "Trinidad and Tobago Dollar",
      "value": "TTD"
  },
  {
      "key": "New Taiwan Dollar",
      "value": "TWD"
  },
  {
      "key": "Tanzanian Shilling",
      "value": "TZS"
  },
  {
      "key": "Ukrainian Hryvnia",
      "value": "UAH"
  },
  {
      "key": "Ugandan Shilling",
      "value": "UGX"
  },
  {
      "key": "Uruguayan Peso",
      "value": "UYU"
  },
  {
      "key": "Uzbekistan Som",
      "value": "UZS"
  },
  {
      "key": "Venezuelan Bolívar",
      "value": "VEF"
  },
  {
      "key": "Vietnamese Dong",
      "value": "VND"
  },
  {
      "key": "CFA Franc BEAC",
      "value": "XAF"
  },
  {
      "key": "CFA Franc BCEAO",
      "value": "XOF"
  },
  {
      "key": "Yemeni Rial",
      "value": "YER"
  },
  {
      "key": "South African Rand",
      "value": "ZAR"
  },
  {
      "key": "Zambian Kwacha",
      "value": "ZMK"
  },
  {
      "key": "Zimbabwean Dollar",
      "value": "ZWL"
  }
]
export const currenciesWithArabic = [
  { key: "US Dollar", value: "USD", arabic: "الدولار الأمريكي" },
  { key: "Canadian Dollar", value: "CAD", arabic: "الدولار الكندي" },
  { key: "Euro", value: "EUR", arabic: "اليورو" },
  { key: "United Arab Emirates Dirham", value: "AED", arabic: "درهم الإمارات العربية المتحدة" },
  { key: "Afghan Afghani", value: "AFN", arabic: "أفغاني أفغاني" },
  { key: "Albanian Lek", value: "ALL", arabic: "ليك ألباني" },
  { key: "Armenian Dram", value: "AMD", arabic: "درام أرميني" },
  { key: "Argentine Peso", value: "ARS", arabic: "بيزو أرجنتيني" },
  { key: "Australian Dollar", value: "AUD", arabic: "الدولار الأسترالي" },
  { key: "Azerbaijani Manat", value: "AZN", arabic: "مانات أذربيجاني" },
  { key: "Bosnia-Herzegovina Convertible Mark", value: "BAM", arabic: "مارك قابل للتحويل للبوسنة والهرسك" },
  { key: "Bangladeshi Taka", value: "BDT", arabic: "تاكا بنغلاديشي" },
  { key: "Bulgarian Lev", value: "BGN", arabic: "ليف بلغاري" },
  { key: "Bahraini Dinar", value: "BHD", arabic: "دينار بحريني" },
  { key: "Burundian Franc", value: "BIF", arabic: "فرنك بوروندي" },
  { key: "Brunei Dollar", value: "BND", arabic: "دولار بروناي" },
  { key: "Bolivian Boliviano", value: "BOB", arabic: "بوليفيانو بوليفي" },
  { key: "Brazilian Real", value: "BRL", arabic: "ريال برازيلي" },
  { key: "Botswanan Pula", value: "BWP", arabic: "بولا بتسواني" },
  { key: "Belarusian Ruble", value: "BYN", arabic: "روبل بيلاروسي" },
  { key: "Belize Dollar", value: "BZD", arabic: "دولار بليزي" },
  { key: "Congolese Franc", value: "CDF", arabic: "فرنك كونغولي" },
  { key: "Swiss Franc", value: "CHF", arabic: "فرنك سويسري" },
  { key: "Chilean Peso", value: "CLP", arabic: "بيزو تشيلي" },
  { key: "Chinese Yuan", value: "CNY", arabic: "يوان صيني" },
  { key: "Colombian Peso", value: "COP", arabic: "بيزو كولومبي" },
  { key: "Costa Rican Colón", value: "CRC", arabic: "كولون كوستاريكي" },
  { key: "Cape Verdean Escudo", value: "CVE", arabic: "إسكودو الرأس الأخضر" },
  { key: "Czech Republic Koruna", value: "CZK", arabic: "كورونا التشيكية" },
  { key: "Djiboutian Franc", value: "DJF", arabic: "فرنك جيبوتي" },
  { key: "Danish Krone", value: "DKK", arabic: "كرونة دنماركية" },
  { key: "Dominican Peso", value: "DOP", arabic: "بيزو جمهورية الدومينيكان" },
  { key: "Algerian Dinar", value: "DZD", arabic: "دينار جزائري" },
  { key: "Estonian Kroon", value: "EEK", arabic: "كرون إستوني" },
  { key: "Egyptian Pound", value: "EGP", arabic: "جنيه مصري" },
  { key: "Eritrean Nakfa", value: "ERN", arabic: "ناكفا إريتري" },
  { key: "Ethiopian Birr", value: "ETB", arabic: "بير إثيوبي" },
  { key: "British Pound Sterling", value: "GBP", arabic: "الجنيه الاسترليني" },
  { key: "Georgian Lari", value: "GEL", arabic: "لاري جورجي" },
  { key: "Ghanaian Cedi", value: "GHS", arabic: "سيدي غاني" },
  { key: "Guinean Franc", value: "GNF", arabic: "فرنك غيني" },
  { key: "Guatemalan Quetzal", value: "GTQ", arabic: "كويتزال غواتيمالي" },
  { key: "Hong Kong Dollar", value: "HKD", arabic: "دولار هونغ كونغ" },
  { key: "Honduran Lempira", value: "HNL", arabic: "ليمبيرا هندوراسية" },
  { key: "Croatian Kuna", value: "HRK", arabic: "كونا كرواتي" },
  { key: "Hungarian Forint", value: "HUF", arabic: "فورنت مجري" },
  { key: "Indonesian Rupiah", value: "IDR", arabic: "روبية إندونيسية" },
  { key: "Israeli New Sheqel", value: "ILS", arabic: "شيكل جديد إسرائيلي" },
  { key: "Indian Rupee", value: "INR", arabic: "روبية هندية" },
  { key: "Iraqi Dinar", value: "IQD", arabic: "دينار عراقي" },
  { key: "Iranian Rial", value: "IRR", arabic: "ريال إيراني" },
  { key: "Icelandic Króna", value: "ISK", arabic: "كرونا آيسلندية" },
  { key: "Jamaican Dollar", value: "JMD", arabic: "دولار جامايكي" },
  { key: "Jordanian Dinar", value: "JOD", arabic: "دينار أردني" },
  { key: "Japanese Yen", value: "JPY", arabic: "ين ياباني" },
  { key: "Kenyan Shilling", value: "KES", arabic: "شيلينغ كيني" },
  { key: "Cambodian Riel", value: "KHR", arabic: "ريال كمبودي" },
  { key: "Comorian Franc", value: "KMF", arabic: "فرنك القمر" },
  { key: "South Korean Won", value: "KRW", arabic: "وون كوري جنوبي" },
  { key: "Kuwaiti Dinar", value: "KWD", arabic: "دينار كويتي" },
  { key: "Kazakhstani Tenge", value: "KZT", arabic: "تينغي كازاخستاني" },
  { key: "Lebanese Pound", value: "LBP", arabic: "ليرة لبنانية" },
  { key: "Sri Lankan Rupee", value: "LKR", arabic: "روبية سريلانكية" },
  { key: "Lithuanian Litas", value: "LTL", arabic: "ليتاس ليتواني" },
  { key: "Latvian Lats", value: "LVL", arabic: "لاتس لاتفي" },
  { key: "Libyan Dinar", value: "LYD", arabic: "دينار ليبي" },
  { key: "Moroccan Dirham", value: "MAD", arabic: "درهم مغربي" },
  { key: "Moldovan Leu", value: "MDL", arabic: "ليو مولدوفي" },
  { key: "Malagasy Ariary", value: "MGA", arabic: "آرياري مدغشقر" },
  { key: "Macedonian Denar", value: "MKD", arabic: "دينار مقدوني" },
  { key: "Myanma Kyat", value: "MMK", arabic: "كيات ميانماري" },
  { key: "Macanese Pataca", value: "MOP", arabic: "باتاكا ماكاوي" },
  { key: "Mauritian Rupee", value: "MUR", arabic: "روبية موريشيوسية" },
  { key: "Mexican Peso", value: "MXN", arabic: "بيزو مكسيكي" },
  { key: "Malaysian Ringgit", value: "MYR", arabic: "رينجيت ماليزي" },
  { key: "Mozambican Metical", value: "MZN", arabic: "ميتيكال موزمبيقي" },
  { key: "Namibian Dollar", value: "NAD", arabic: "دولار ناميبي" },
  { key: "Nigerian Naira", value: "NGN", arabic: "نايرا نيجيري" },
  { key: "Nicaraguan Córdoba", value: "NIO", arabic: "كوردوبا نيكاراغوي" },
  { key: "Norwegian Krone", value: "NOK", arabic: "كرونة نرويجية" },
  { key: "Nepalese Rupee", value: "NPR", arabic: "روبية نيبالية" },
  { key: "New Zealand Dollar", value: "NZD", arabic: "دولار نيوزيلندي" },
  { key: "Omani Rial", value: "OMR", arabic: "ريال عماني" },
  { key: "Panamanian Balboa", value: "PAB", arabic: "بالوبا بنامي" },
  { key: "Peruvian Nuevo Sol", value: "PEN", arabic: "نويفو سول بيروفي" },
  { key: "Philippine Peso", value: "PHP", arabic: "بيزو فلبيني" },
  { key: "Pakistani Rupee", value: "PKR", arabic: "روبية باكستانية" },
  { key: "Polish Zloty", value: "PLN", arabic: "زلوتي بولندي" },
  { key: "Paraguayan Guarani", value: "PYG", arabic: "غواراني باراغواي" },
  { key: "Qatari Rial", value: "QAR", arabic: "ريال قطري" },
  { key: "Romanian Leu", value: "RON", arabic: "ليو روماني" },
  { key: "Serbian Dinar", value: "RSD", arabic: "دينار صربي" },
  { key: "Russian Ruble", value: "RUB", arabic: "روبل روسي" },
  { key: "Rwandan Franc", value: "RWF", arabic: "فرنك رواندي" },
  { key: "Saudi Riyal", value: "SAR", arabic: "ريال سعودي" },
  { key: "Sudanese Pound", value: "SDG", arabic: "جنيه سوداني" },
  { key: "Swedish Krona", value: "SEK", arabic: "كرونا سويدية" },
  { key: "Singapore Dollar", value: "SGD", arabic: "دولار سنغافوري" },
  { key: "Somali Shilling", value: "SOS", arabic: "شيلينغ صومالي" },
  { key: "Syrian Pound", value: "SYP", arabic: "ليرة سورية" },
  { key: "Thai Baht", value: "THB", arabic: "بات تايلاندي" },
  { key: "Tunisian Dinar", value: "TND", arabic: "دينار تونسي" },
  { key: "Tongan Paʻanga", value: "TOP", arabic: "بانغا تونغي" },
  { key: "Turkish Lira", value: "TRY", arabic: "ليرة تركية" },
  { key: "Trinidad and Tobago Dollar", value: "TTD", arabic: "دولار ترينيداد وتوباغو" },
  { key: "New Taiwan Dollar", value: "TWD", arabic: "دولار تايوان الجديد" },
  { key: "Tanzanian Shilling", value: "TZS", arabic: "شيلينغ تنزاني" },
  { key: "Ukrainian Hryvnia", value: "UAH", arabic: "هريفنيا أوكرانية" },
  { key: "Ugandan Shilling", value: "UGX", arabic: "شيلينغ أوغندي" },
  { key: "Uruguayan Peso", value: "UYU", arabic: "بيزو أوروغوياني" },
  { key: "Uzbekistan Som", value: "UZS", arabic: "سوم أوزبكي" },
  { key: "Venezuelan Bolívar", value: "VEF", arabic: "بوليفار فنزويلي" },
  { key: "Vietnamese Dong", value: "VND", arabic: "دونغ فيتنامي" },
  { key: "CFA Franc BEAC", value: "XAF", arabic: "فرنك س ف ا ب" },
  { key: "CFA Franc BCEAO", value: "XOF", arabic: "فرنك س ف ا ب" },
  { key: "Yemeni Rial", value: "YER", arabic: "ريال يمني" },
  { key: "South African Rand", value: "ZAR", arabic: "راند جنوب أفريقي" },
  { key: "Zambian Kwacha", value: "ZMK", arabic: "كواشا زامبي" },
];
export const checkUnitsWithStandardType = (type) => {
  let data = []
  switch (type) {
    case 'metric':
      data = [{
        'distanceUnit': {
          key: 'km',
          name: 'sharedKm',
          factor: 0.001
        },
        'speedUnit': {
          key: 'kmh',
          name: 'sharedKmh',
          factor: 1.852
        },
        'volumeUnit': {
          key: 'ltr',
          name: 'sharedLiterAbbreviation',
          fullName: 'sharedLiter',
          factor: 1
        }
      }]
      break;
    case 'imperial':
      data = [{
        'distanceUnit': {
          key: 'mi',
          name: 'sharedMi',
          factor: 0.000621371
        },
        'speedUnit': {
          key: 'mph',
          name: 'sharedMph',
          factor: 1.15078
        },
        'volumeUnit': {
          key: 'impGal',
          name: 'sharedUkGallonAbbreviation',
          fullName: 'sharedUkGallon',
          factor: 4.546                 //3.785 changed to 4.546 //jawad
        }
      }]
      break;
    case 'US':
      data = [{
        'distanceUnit': {
          key: 'mi',
          name: 'sharedMi',
          factor: 0.000621371
        },
        'speedUnit': {
          key: 'mph',
          name: 'sharedMph',
          factor: 1.15078
        },
        'volumeUnit':{
          key: 'usGal',
          name: 'sharedUsGallonAbbreviation',
          fullName: 'sharedUsGallon',
          factor: 3.785
        }
      }]
      break;
    case 'metricWithUSGallons':
      data = [{
        'distanceUnit': {
          key: 'km',
          name: 'sharedKm',
          factor: 0.001
        },
        'speedUnit': {
          key: 'kmh',
          name: 'sharedKmh',
          factor: 1.852
        },
        'volumeUnit':
        {
          key: 'usGal',
          name: 'sharedUsGallonAbbreviation',
          fullName: 'sharedUsGallon',
          factor: 3.785
        }
      }]
      break;
    default:
      data = [
      ]
  }
  return data
}